var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('reservation-calendar',{attrs:{"client-or-member-id":_vm.id},on:{"close":_vm.backOrClose,"next":_vm.next}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }